<script>
import lazyLoadComponent from '@router/lazyload-component'
import { genderFilter, orderStatusFilter, paymentStatusMapFilter } from '@utils/filter-value-to-text'
import formatDate, { formatGetTime } from '@utils/format-date'
import { membreLevelValidityTime } from '@utils/memberLevel'
import memberLevelDiscountMixin from '@src/mixins/memberLevelDiscountMixin'
import orderFormMixin from '@/src/mixins/orderFormMixin'
import { cloneDeep } from 'lodash'
import depositOrderMixin from '@/src/mixins/depositOrderMixin'
const initData = () => {
  return {
    params: [],
    fullName: '',
    gender: 'female',
    phoneCode: '+886',
    phoneNumber: '',
    email: '',
    note: '',
    status: 2,
    paymentStatus: 'UNPAID',
    memberId: '',
    paymentMethod: 'Cash',
    bankType: '',
    groupSize: 1,
    type: 'deposit',
  }
}

export default {
  components: {
    BaseStateLabel: () => lazyLoadComponent(import('@components/BaseStateLabel')),
    BaseCollapse: () => lazyLoadComponent(import('@components/BaseCollapse')),
    MemberSearchForm: () => lazyLoadComponent(import('./components/MemberSearchForm')),
    MemberForm: () => lazyLoadComponent(import('./components/MemberForm')),
    MemberInfo: () => lazyLoadComponent(import('./components/MemberInfo')),
    PaymentFormDialog: () => lazyLoadComponent(import('./components/PaymentFormDialog')),
    TotalStatement: () => lazyLoadComponent(import('./components/TotalStatement')),
    DepositList: () => lazyLoadComponent(import('./components/DepositList')),
    OrderMemberInfo: () => lazyLoadComponent(import('./components/OrderMemberInfo')),
    SignatureDialog: () => lazyLoadComponent(import('@components/SignatureDialog')),
  },
  filters: {
    formatDate,
    orderStatusFilter,
    genderFilter,
    paymentStatusMapFilter,
  },
  mixins: [memberLevelDiscountMixin, orderFormMixin, depositOrderMixin],
  props: {
    defaultValue: {
      type: Object,
      default: () => initData(),
    },
    orderMemberId: {
      type: String,
      default: '',
    },
    orderType: {
      type: String,
      validator: (val) => {
        return ['reservation', 'prepaid', 'deposit'].includes(val)
      },
      required: true,
    },
    /**
     * @description 第二形態（給立即抵扣使用）
     */
    orderSecondType: {
      type: String,
      default: 'deposit'
    }
  },
  data() {
    return {

      orderHeaderId: `orderHeader__${Math.floor(Math.random() * 10000)}`,
      headerHeight: 0,
      componentKey: 0,
      submitData: Object.assign({}, initData()),
      userSameAsMember: true,
      visibleMemberInfo: false,
      visibleMemberInfoEdit: false,
      visibleMemberSearch: true,
      tryingGetMember: false,

      // 變價或加購
      totalAllShow: false,

      paymentWay: 'offline',
      paymentDialogVisible: false,
      extraDialogVisible: false,
      tryingStore: false,

      depositList: [],
      // 會員資訊
      memberInfo: {
        tags: [],
        phoneCode: '',
        phoneNumber: '',
        level: {}
      },
      memberInfoActiveTab: 'information',
      memberInfoShow: false,

    }
  },
  computed: {
    mainText() {
      const textType = {
        'deposit': '儲值',
        'deduct': '抵扣'
      }
      return textType[this.orderSecondType] ?? ' '
    },
    /**
     * @description container 的客戶資訊
     */
    payPersonInfo() {
      let obj = {}
      if (Object.keys(this.submitData).length > 0) {
        obj = {
          paymentMethod: this.submitData.paymentMethod || '',
          paymentStatus: this.submitData.paymentStatus || '',
          allowExpired: this.submitData.allowExpired || '',
          phoneCode: this.submitData.phoneCode || '',
          phoneNumber: this.submitData.phoneNumber || '',
          fullName: this.submitData.fullName || '',
          gender: this.submitData.gender || '',
          email: this.submitData.email || '',
          note: this.submitData.note || '',
        }
      }
      return obj
    },
    depositReduce() {
      const { bonus, point } = this.memberInfo.depositInfo.solution2.reduceDepositTotal
      return bonus + point
    },
    depositItem() {
      return this.submitData.params.find(({ type }) => type === 'deposit-plan') || {}
    },
    submitPriceTotal() {
      return this.composeTotal(this.depositItem)
    },
    submitRules() {
      const isTaiwan = this.submitData.phoneCode === '+886'
      return {
        phoneNumber: [
          {
            required: true,
            message: '請填寫手機號碼',
            trigger: 'blur',
          },
          {
            pattern: isTaiwan ? /^09\d{8}$/ : '',
            message: '格式請符合 09XXXXXXXX',
            trigger: 'blur',
          },
        ],
        email: [
          {
            required: true,
            message: '請輸入 Email',
          },
          {
            type: 'email',
            message: '請輸入正確的 Email 格式',
          },
        ],
        fullName: [
          {
            required: true,
            message: '請輸入使用人姓名',
          },
        ],
        gender: [
          {
            required: true,
            message: '請選擇性別',
          },
        ],
      }
    },
    hasDepositItem() {
      if (this.orderSecondType === 'deposit') {
        return this.depositItem.title !== '' && this.depositItem.title !== undefined && !!this.depositItem.point && this.depositItem.price > -1
      } else {
        return this.depositItem.title !== '' && this.depositItem.title !== undefined && this.depositItem.price > -1
      }

    },
    isFormValid() {
      if (!this.hasDepositItem) return false
      if (this.depositItem.id) return true
      if (this.orderSecondType === 'deposit') {
        return this.depositItem.title.length > 4
      }
      if (this.orderSecondType === 'deduct') {
        return this.depositItem.title.length > 0
      }

    },
    /*************** 會員等級效期 ***************/
    validityTime() {
      const startedAt = this.memberInfo.level.startedAt
      const expiredAt = this.memberInfo.level.expiredAt
      return membreLevelValidityTime(startedAt, expiredAt)
    },
    /*************** 當前訂單會員等級的折扣 ***************/
    memberLevelDiscount() {
      if (this.submitData.params.length > 0) {
        return this.composeMemberLevelDiscount(this.submitData.params[0])
      } else {
        return 0
      }
    },
  },
  watch: {
    memberInfo: 'updateUserByMember',
    userSameAsMember: 'updateUserByMember',
  },
  created() {
    if (this.orderMemberId) {
      this.visibleMemberSearch = false
      this.tryToFetchMemberInfo(this.orderMemberId)
    }
  },
  mounted() {
    this.$nextTick(() => {
      const interval = setInterval(() => {
        if (document.querySelector(`#${this.orderHeaderId}`) !== null) {
          clearInterval(interval)
          this.headerHeight = document.querySelector(`#${this.orderHeaderId}`).offsetHeight + 40
        }
      }, 500)
    })
  },
  methods: {
    /**
     * @description 取得儲值金方案列表
     */
    async fetchDeposit(memberId) {
      const { items } = await this.$store.dispatch('deposit/fetchListAll', { paginate: 0, memberId })
      this.depositList = items.filter(item => item.state === 1)
    },
    scrollToBottom() {
      this.$nextTick(() => {
        this.$refs.leftCont.scrollTop = 1000
      })
    },
    closeLayout() {
      this.visibleMemberInfoEdit = false
      this.memberInfoShow = false
    },
    resetData() {
      this.submitData.params = []
    },
    createMember(val) {
      this.memberInfo = { ...val }
      this.visibleMemberInfoEdit = true
    },
    clearMemberInfo() {
      this.closeLayout()
      this.memberInfo = {}
      this.resetData()
      this.visibleMemberSearch = true
    },
    closeMemberInfo() {
      this.memberInfoShow = false
    },
    showMemberInfo() {
      this.memberInfoShow = true
    },
    /************ 編輯客戶資訊相關 start ************/
    closeEditMemberForm() {
      this.visibleMemberInfoEdit = false
    },
    async tryToFetchMemberInfo(memberId) {
      this.tryingGetMember = true
      this.memberInfo = await this.$store.dispatch('member/fetchSingle', { memberId })

      this.closeEditMemberForm()

      this.visibleMemberSearch = false
      this.tryingGetMember = false
      this.scrollToBottom()
      this.fetchDeposit(memberId)
    },
    /**
     * @description 驗證成本價是否可以通過
     */
    async validateCostPrice(submitData) {
      return new Promise((resolve, reject) => {
        const { params } = submitData
        const setCostPriceToNull = () =>{
          this.$set(params[0], 'costPrice', null)
        }
        // 如果是自訂方案，則做下面驗證
        if ('priceId' in params[0] && !params[0].priceId) {
          const { costPrice } = params[0]
          const numericValue = parseFloat(costPrice);
          // 若為null or 空字串：則讓他變回null
          if(costPrice === null || costPrice.length === 0){
            setCostPriceToNull()
            resolve()
          }
          if (!isNaN(numericValue) && isFinite(numericValue) && numericValue >= 0) {
            // 若為數字讓他過
            resolve()
          } else {
            // 若不是數字，噴錯
            reject(new Error('成本價請填入數字'))
          }
        }
        // 如果非自訂方案，而是已經有的方案則走這邊
        if ('priceId' in params[0] && params[0].priceId) {
          resolve()
        }
      })
    },
    /************ 編輯客戶資訊相關 end ************/
    async handleStoreOrder(type) {
      try {
        await this.validateFullName(this.submitData.fullName)
        await this.validateCostPrice(this.submitData)
        if (this.orderSecondType === 'deposit') {
          const isNegative = this.submitPriceTotal < 0
          if (isNegative) {
            this.$confirm('訂單金額不能小於0', '提醒', {
              confirmButtonText: '確定',
              showCancelButton: false,
              type: 'warning',
              center: true,
            })
            return
          }
          this.paymentDialogVisible = true
        }
        if (this.orderSecondType === 'deduct') {
          await this.$store.dispatch('merchant/deductSave', {
            member_id: this.submitData.memberId,
            type: 'paid',
            extraInfo: {
              price_title: this.submitData.params[0].title,
              type: 'customize'
            },
            point: this.submitData.params[0].price
          })
          this.paymentDialogVisible = false
          this.extraDialogVisible = false
          this.emitStore()
        }
      } catch (error) {
        console.error(error.message)
        this.$message.error(error.message)
      }
    },
    /**
     * @description for container 所以 paymentMethod / isPaid：架空
     */
    async onSubmitPaymentForm(data) {
      const { paymentMethod, Card4No, PayerAccount5Code, bankType, isPaid } = data
      this.submitData = {
        ...this.submitData,
        paymentMethod,
        Card4No,
        PayerAccount5Code,
        bankType,
        paymentStatus: isPaid ? 'PAID' : 'UNPAID',
      }
      await this.setInvoiceInfo(cloneDeep(this.submitData), 'deposit-form')
      this.paymentDialogVisible = false
      this.goToExtrafields()
    },
    goToExtrafields() {
      if (!this.submitData.fullName) {
        this.userSameAsMember = false
      } else {
        this.userSameAsMember = true
      }
      this.handleCreateOrder()
    },
    updateUserByMember() {
      const fields = ['memberId', 'fullName', 'gender', 'phoneCode', 'phoneNumber', 'email']
      fields.forEach((field) => {
        this.submitData[field] = field === 'memberId' ? this.memberInfo.id : this.memberInfo[field]
      })
    },
    async handleCreateOrder() {
      if (!this.depositItem.canBuy) {
        await this.$confirm('此會員並沒有購買儲值金的資格，是否還是要代客儲值？', '提醒', {
          confirmButtonText: '確定',
          type: 'warning',
          center: true,
        })
      }
      const isBeforeExpired = this.memberInfo.level.expiredAt === null || new Date() <= new Date(formatGetTime(this.memberInfo.level.expiredAt))
      if (!isBeforeExpired) return this.errorCurrentMemberLevel()
      this.tryToCreateOrder()
    },
    async tryToCreateOrder() {
      const storeData = {
        ...this.submitData,
        paymentMethod: '', // 這邊是覆蓋掉submitData的paymentMethod
        paymentStatus: '',// 這邊是覆蓋掉submitData的paymentStatus
        basePrice: this.depositItem.price,
        total: this.submitPriceTotal,
        point: this.depositItem.point,
        ...this.invoiceStoreData,
        invoice: this.invoiceStoreData
      }
      this.tryingStore = true
      try {
        // 假的儲值金儲值資料
        // await this.postFakeDepositStoreData(storeData)
        // return 
        // 假的儲值金儲值資料
        const orderResult = await this.$store.dispatch('deposit/orderStore', storeData)
        await this.storeContainer(orderResult)
        let requirePay = storeData.status === 2
        this.handleCreateSuccess(requirePay)
      } catch (error) {
        this.$message({
          type: 'error',
          message: `Server Error`,
        })
      } finally {
        this.tryingStore = false
      }
    },
    /**
     * @description 新增假的儲值金資料
     */
    async postFakeDepositStoreData(storeData) {
      for (let i = 0, len = 20; i < len; i++) {
        const orderResult = await this.$store.dispatch('deposit/orderStore', storeData)
        await this.storeContainer(orderResult)
      }
    },
    /**
     * @description container 儲值
     */
    async storeContainer(orderResult) {
      try {
        const baseObj = {
          bankType: this.submitData.bankType ?? '',
          uuid: orderResult.orderContainerUuid,
          total: orderResult.unpaidTotal,
          ...this.payPersonInfo,
          ...this.invoiceStoreData
        }
        await this.$store.dispatch('order/storeContainerId', Object.assign({}, baseObj, this.getPaymentCardNo()))
      } catch (error) {
        console.error(error.message)
      }

    },
    /**
     * @description 如果是ATM or 信用卡 返回付款資訊的末四碼or五碼
     */
    getPaymentCardNo() {
      try {
        if (this.payPersonInfo.paymentMethod === 'Atm') {
          return {
            'PayerAccount5Code': this.submitData.PayerAccount5Code || ''
          }
        }
        if (this.payPersonInfo.paymentMethod === 'StoreCredit') {
          return {
            'Card4No': this.submitData.Card4No || ''
          }
        }
        return {}
      } catch (error) {
        console.error(error.message)
      }
    },
    handleCreateSuccess(requirePay = false) {
      this.extraDialogVisible = false
      this.emitStore()
      if (this.orderSecondType === 'deposit') {
        this.$alert(`已發送${requirePay ? '付款' : '訂單'}連結至使用人 Email`, '訂單新增成功！', {
          confirmButtonText: '確認',
          center: true,
        })
      }
    },
    onUpdateDepositList(data) {
      data = this.fixParamsData(data)
      this.submitData.params = [{ ...data }]
    },
    /**
     * @description 確保如果非自訂的儲值方案，costPrice 為 null
     */
    fixParamsData(data) {
      if (data.priceId !== 'custom' && this.orderSecondType === 'deposit' && data.id) {
        this.$set(data, 'costPrice', null)
      }
      return data
    },
    /**
     * @description 儲存成功之後，emit出去，讓外部更新
     */
    emitStore() {
      this.$emit('store')
    },
    errorCurrentMemberLevel() {
      this.$alert(`超過會員等級方案"${this.memberInfo.level.title}"截止時間，請重新下單`, {
        title: `提示`,
        showClose: false,
        dangerouslyUseHTMLString: true
      })
        .then(() => {
          this.tryToFetchMemberInfo(this.memberInfo.id)
          this.extraDialogVisible = false
        });
    },
    goToMemberInfoDetail(val) {
      this.closeAllInfo()
      this.memberInfoShow = true
      this.memberInfoActiveTab = val
    },
    closeAllInfo() {
      this.memberInfoShow = false
    },
  },
}
</script>
<template>
  <div v-loading="tryingGetMember" :class="$style.orderformSection">
    <div v-if="!totalAllShow" class="orderformSection__all">
      <div class="orderformSection__left">
        <div :id="orderHeaderId" :class="$style.header">
          <h5 class="Jost" :class="$style.title">代客{{ mainText }}</h5>
          <div v-if="hasDepositItem" class="Jost fs-4" style="padding-right: 20px">
            <div class="inline-between text-secondary-light">
              <span>{{ depositItem.title }}</span>
              <span v-if="orderSecondType === 'deposit'" class="Jost">點數：<span class="text-primary">{{ depositItem.point
              }} 點</span></span>
            </div>
          </div>
        </div>
        <div ref="leftCont" class="orderformSection__left__content" :style="`height:calc(100vh - ${headerHeight}px)`">
          <template v-if="visibleMemberSearch">
            <MemberSearchForm @create="createMember" @update="tryToFetchMemberInfo" />
          </template>
          <div v-else style="min-height: 300px; padding-top: 20px" class="info-section">
            <template v-if="memberInfo.id">
              <!-- 客戶資訊 -->

              <template>
                <BaseCollapse expanded is-order :order-theme="true" arrow-style="far">
                  <template v-slot:title>
                    <span>
                      <BaseIcon icon-style="fal" name="address-card"
                        :class="[$style['header-icon-left'], 'fs-2xl', 'mr-3', 'align-text-bottom']" />
                      客戶資訊
                    </span>
                  </template>
                  <OrderMemberInfo :member-info="memberInfo" @toDetail="goToMemberInfoDetail" />
                </BaseCollapse>
              </template>
              <!-- 選擇儲值方案 -->
              <BaseCollapse v-if="orderSecondType === 'deposit'" expanded is-order :order-theme="true">
                <template v-slot:title>
                  <span>
                    <BaseIcon icon-style="fal" name="usd-circle" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" />
                    選擇儲值方案
                  </span>
                </template>
                <DepositList :list="depositList" :order-second-type="orderSecondType" @update="onUpdateDepositList" />
              </BaseCollapse>
              <!-- 選擇抵扣方案 -->
              <BaseCollapse v-if="orderSecondType === 'deduct'" expanded is-order :order-theme="true">
                <template v-slot:title>
                  <span>
                    <BaseIcon icon-style="fal" name="usd-circle" :class="[$style['header-icon-left'], 'fs-lg', 'mr-3']" />
                    選擇抵扣方案
                  </span>
                </template>
                <DepositList :list="[]" :order-second-type="orderSecondType" @update="onUpdateDepositList" />
              </BaseCollapse>
            </template>
          </div>
        </div>
      </div>

      <div class="orderformSection__right">
        <template>
          <!-- 客戶編輯 -->
          <template v-if="visibleMemberInfoEdit">
            <MemberForm :default-value="memberInfo" @update="tryToFetchMemberInfo" @close="closeEditMemberForm" />
          </template>
          <!-- 客戶資訊 -->
          <template v-if="memberInfoShow && !visibleMemberInfoEdit">
            <MemberInfo :member-info-active-tab="memberInfoActiveTab" :member-info="memberInfo"
              @update="tryToFetchMemberInfo" @close="closeMemberInfo" />
          </template>
        </template>
        <!-- 變價 -->
        <template>
          <div :class="$style.total">
            <div class="total__cont">
              <TotalStatement order-type="deposit" :order-second-type="orderSecondType" :member-info="memberInfo"
                :default-value="submitData" />
            </div>
            <div v-if="orderSecondType === 'deposit'" class="total__bottom">
              <div style="display: flex; margin-bottom: 10px">
                <h6>付款方式</h6>
              </div>
              <el-radio-group v-model="paymentWay">
                <el-radio label="offline" border>線下付款</el-radio>
                <el-radio v-if="$cashFlowSettingPass()" label="online" border>線上付款</el-radio>
              </el-radio-group>
            </div>
          </div>
        </template>
      </div>
      <!-- 底部按鈕 -->
      <div class="orderformSection__bottom">
        <div style="display: flex; align-items: center">
          <BaseStateLabel v-if="defaultValue.status === 0" class="is-border"
            :state="defaultValue.status | orderStatusFilter('color')">
            {{ defaultValue.status | orderStatusFilter('text') }}
          </BaseStateLabel>
          <BaseStateLabel v-else class="is-border" :state="defaultValue.paymentStatus | paymentStatusMapFilter('color')">
            {{ defaultValue.paymentStatus | paymentStatusMapFilter('text') }}
          </BaseStateLabel>
          <div style="padding-left: 20px" class="text-secondary fw-medium Jost">
            應付 NT${{ submitPriceTotal }}
            <div v-if="!hasDepositItem" class="text-muted-0" style="padding-top: 5px">未選擇方案</div>
          </div>
        </div>
        <el-button class="is-round orderformSection__bottom__btn" type="primary" :disabled="tryingStore || !isFormValid"
          :loading="tryingStore" @click="handleStoreOrder">
          立即{{ mainText }}
        </el-button>
      </div>
    </div>

    <!-- 選擇付款方式和訂單狀態 -->
    <PaymentFormDialog :visible.sync="paymentDialogVisible" :payment-way="paymentWay" :loading="tryingStore"
      @submit="onSubmitPaymentForm" />

    <!-- 簽名請款 -->
    <SignatureDialog :one-step="true" :start-tab="1" :member-info="memberInfo" :props-store-invoice-setting="1"
      :visible.sync="signDialogVisible" :order="{ ...submitData }" @closeSignature="closeSignature"
      @closeSignaturDialog="closeSignaturDialog" />
  </div>
</template>
<style lang="scss" module>

.orderformSection {

  // display: flex;
  // flex-wrap: wrap;
  // height: 100%;
  :global {
    .form-block-title {
      font-size: 16px;
      padding-bottom: 0;
      margin-top: 0;
    }

    .el-form-item {
      // margin-bottom: 10px;
    }

    .el-tabs__active-bar {
      background-color: $color-primary !important;
    }

    .info-section {
      padding: 30px 40px;

      @include max-lg {
        padding: 15px 20px;
      }
    }

    .orderformSection {
      &__all {
        width: 100%;
        display: flex;
        flex-wrap: wrap;
        height: 100%;
        // display: none;
      }

      &__left {
        width: 57%;
        border-right: $color-border-base 1px solid;
        display: flex;
        flex-direction: column;
        justify-content: stretch;
        background: $color-line;

        &__content {
          height: 100vh;
          overflow: auto;

          padding-bottom: 90px;
        }
      }

      &__right {
        position: relative;
        width: 43%;
        background: $color-line;

        .orderformSection__right__header {
          background-color: $color-line;
          z-index: 999;
        }

        &__title {
          margin: 0;
          padding: 19px 0;
          padding-left: 50px;
        }

        &__header {
          position: relative;
          border-bottom: $color-border-base 1px solid;

          .el-drawer__close-btn {
            // font-weight: 300;
            color: #72767b;
            position: absolute;
            padding: 15px;
            border: 0;
            left: 0;
            top: 3px;
          }

          .el-tabs__item {
            height: auto;
            padding: 10px 0;
          }

          .el-tabs__nav-wrap::after {
            display: none;
          }

          .el-tabs__header {
            margin-bottom: 0;
          }

          .el-tabs--top {
            margin-left: 60px;

            @include max-lg {
              margin-left: 30px;
            }
          }
        }

        &__content {
          z-index: 10;
          height: calc(100vh - 60px);
          overflow: auto;
          padding: 30px;
          padding-bottom: 120px;
          position: relative;
          background-color: $color-line;

          @include max-lg {
            padding: 20px;
          }
        }
      }

      &__bottom {
        position: absolute;
        width: 100%;
        bottom: 0;
        left: 0;
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 20px 30px;
        background: #fff;
        box-shadow: 0 -5px 5px rgba(#eee, 0.3);
        z-index: 999;

        @include touch {
          position: static;
          // position: fixed;
        }

        &__btn {
          width: 40%;
        }

        &__btn-item {
          min-width: 132px;
          // width: 100%;
        }
      }
    }
  }
}

.header {
  margin-top: 5px;
  // margin-bottom: 30px;
  padding-left: 60px;
  padding-right: 40px;
  padding-bottom: 10px;
  border-bottom: $color-border-base 1px solid;

  @include max-lg {
    padding-right: 20px;
  }

  :global {
    h5 {
      font-size: 18px;
    }
  }
}

.title:not(:first-child) {
  margin-top: 30px;
}

.infoList {
  // margin-bottom: 30px;
  padding-top: 5px;

  // border-bottom: 1px solid $color-border-base;
  // font-size: 16px;
  :global {
    .muted {
      color: $color-text-secondary;
    }

    .el-tag+.el-tag {
      margin-left: 10px;
    }

    .infoList {
      &__title {
        font-weight: 500;
        margin-bottom: 20px;
      }

      &__item {
        margin-bottom: 15px;
      }

      &__row {
        margin-bottom: 20px;
      }
    }
  }
}

.total {
  position: absolute;
  left: 0;
  top: 0;
  right: 0;
  height: 100%;
  z-index: 1;

  @include touch {
    position: static;
  }

  :global {
    .total {
      &__cont {
        // height: calc(100% - 80px);
        height: calc(100% - 217px);

        @include touch {
          height: auto;
        }
      }

      &__bottom {
        padding: 30px 30px;
        position: absolute;
        bottom: 80px;
        width: 100%;
        border-top: $color-border-base 1px solid;

        h6 {
          margin-top: 0;
        }

        :global {
          .el-radio-group {
            display: flex;
          }

          .el-radio {
            margin-right: 0;
            padding-right: 12px;
            border-radius: 7px;
            margin-left: 0;
            width: 100%;
            background-color: #fff;
          }
        }
      }
    }
  }
}

.bottom {
  /* position: absolute;
  bottom: 0; */
  width: 100%;
  padding: 0 30px 0;

  @include touch {
    position: static;
  }
}
</style>
